import { Modal, Button, Form } from "react-bootstrap";

export default function UpdateDurationModal({
  show,
  onClose,
  value,
  onChange,
  onSubmit,
  loading = false,
}) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Duration</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group controlId="notifyDesc" className="mb-2">
          <Form.Label>Duration (in Hours)</Form.Label>
          <Form.Control
  type="number"
  min={1}
  max={1000}
  value={value}
  placeholder=""
  onChange={(e) => {
    const val = e.target.value;

    // ✅ allow user to clear input
    if (val === "") {
      onChange("");
      return;
    }

    const num = Number(val);

    if (num >= 1 && num <= 1000) {
      onChange(num);
    }
  }}
/>

        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? "Sending…" : "Send"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
